module.exports = __webpack_public_path__ + "static/gone-tomorrow-331abc54f3f8e92d00fb7c00e0ef07c4.jpg";